import React, { Component } from 'react';
import '../styles/App.css';
import AboutLinks from './footer-links/about-links.js';
const snapSize = 650;


class HelpAndCurrency extends Component {
  constructor(props){
    super(props);

        this.state= {
          media: null,
          parent: {}
        }

        this.setMedia = this.setMedia.bind(this)

      };

      setMedia() {
       this.setState({media: window.innerWidth});
     }

     componentWillMount(){
       this.setMedia();
     }

      componentDidMount(){
        window.addEventListener("resize", this.setMedia);
      }


  render() {
    let media = this.state.media;

    let aboutLinks = null;
    if (media <snapSize+1){
      aboutLinks = <AboutLinks />;
    }

    return (
      <div className="HelpAndCurrency">
        {aboutLinks}
      </div>
    );
  }
}

export default HelpAndCurrency;
